import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';

const usePermissions = () => {
  const givePermissions = useCallback(async (val) => {
    try {
      return await ajax.post(`user-permissions/give`, val);
    } catch (error) {
      return error;
    }
  });

  const getPermissions = useCallback(async (val) => {
    try {
      const value = { userId: val };
      return await ajax.post(`user-permissions/get-all`, value);
    } catch (error) {
      return error;
    }
  });

  const getPermissionId = useCallback(async (val) => {
    try {
      const value = { permissionShortName: val };
      return await ajax.post(`user-permissions/get-id`, value);
    } catch (error) {
      return error;
    }
  });

  const removePermissions = useCallback(async (userId) => {
    try {
      const value = { userId: userId };
      await ajax.post(`user-permissions/remove`, value);
    } catch (error) {
      return error;
    }
  });

  return {
    givePermissions,
    getPermissions,
    removePermissions,
    getPermissionId,
  };
};

export default usePermissions;
